import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import css from './CwShellLeftNavLink.scss';
import CwImage from '../../cwimage/CwImage';
import CwLabel from '../../cwlabel/CwLabel';

const CwShellLeftNavLink = (props) => {

  const iconSource = props.active ? props.collapseIcon : props.expandIcon;

  const linkClass = cx(
    css.cwShellLeftNavLink,
    {
      [css.active]: props.active
    }
  );

  const subLinkContainerClass = cx(
    css.cwShellLeftNavSubLinkContainer,
    {
      [css.active]: props.active
    }
  );

  const handleClick = () => {
    // fire onClick callback if it exists
    if (typeof props.onClick === 'function') {
      props.onClick();
    }
    // set this as the active link if the menu is in FAT mode
    if (typeof props.setActiveLink === 'function') {
      props.setActiveLink(props.id);
    }
  };

  return (
  <div>
    <div
      className={linkClass}
      onClick={handleClick}
    >
      <CwLabel className={css.cwShellLeftNavButtonLabel}>
        {props.label}
      </CwLabel>
      {props.children.length !== 0 &&
      <CwImage
        className={css.cwShellLeftNavLinkIcon}
        src={iconSource}
      />
      }
    </div>
    {props.active &&
    <div className={subLinkContainerClass}>
      {props.children}
    </div>
    }
  </div>
  );
};

CwShellLeftNavLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.shape({
      type: PropTypes.oneOf([CwShellLeftNavLink])
    }),
    PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.oneOf([CwShellLeftNavLink])
    }))
  ]),
  /**
   * Unique identifier
   */
  id: PropTypes.number,
  /**
   * Determines if the 'active' class is applied to button
   */
  active: PropTypes.bool,
  /**
   * Path to collapse icon
   */
  collapseIcon: PropTypes.string,
  /**
   * Path to collapse icon
   */
  expandIcon: PropTypes.string,
  /**
   * Text Displayed
   */
  label: PropTypes.string.isRequired,
  /**
   * Callback function that is fired on mouse click
   */
  onClick: PropTypes.func,
  /**
   * Callback function to set the active link
   */
  setActiveLink: PropTypes.func
};

CwShellLeftNavLink.defaultProps = {
  children: []
};

export default CwShellLeftNavLink;


// WEBPACK FOOTER //
// ./src/components/cwshellleftnav/cwshellleftnavlink/CwShellLeftNavLink.jsx